import {IIdiomas} from "services-comun/modules/net/idiomas";

export default Object.freeze({
    idiomas: ['de', 'en', 'es', 'fr', 'it', 'nl', 'pt-BR', 'pt-PT', 'ru'],
    defecto: "en",
    enabled: true,
} as IIdiomas);

export const soportados = ["en", "es", "fr", "de", "it", "pt-PT"];
